import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoNomineDelegheConservazioneStep2Component } from './conservazione-carica-documento-nomine-deleghe-conservazione-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-nomine-deleghe-conservazione-step2', {
            url: '/conservazione-carica-documento-nomine-deleghe-conservazione',
            ncyBreadcrumb: {
                label: 'Nomine e Deleghe di Conservazione',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-nomine-deleghe-conservazione-step2 flex="100"></conservazione-carica-documento-verbali-verifica-scarto-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoNomineDelegheConservazioneStep2Module: string = ng
    .module('conservazione-carica-documento-nomine-deleghe-conservazione-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoNomineDelegheConservazioneStep2', ConservazioneCaricaDocumentoNomineDelegheConservazioneStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-nomine-deleghe-conservazione-step2/conservazione-carica-documento-nomine-deleghe-conservazione-step2.module.ts